import type { Me } from '../lib/me'
import { can, canGallery } from '../lib/me'
import { canReachShopAdmin } from '../lib/shop'
import { myLanes } from '../lib/support'
import { supabase } from '../lib/supabase'
import { initialsOf } from '../lib/initials'
import { AppShell } from '../components/AppShell'
import { AdminHomeCards } from '../components/AdminHomeCards'

/**
 * #/admin — the admin home (SHL-33, David 10 Oct: "One Admin entry -> admin
 * home"). The identity menu's single "Admin" row opens it.
 *
 * Until 11 Oct #/admin WAS People and roles; that page is #/admin/people now.
 * No bell row, guide or migration linked to the bare #/admin (checked 11 Oct),
 * so nothing that pointed at People and roles lands here by surprise — and if
 * something did, People and roles is the first card.
 *
 * The cards come from the shell's own filtered NAV through context (rule 11),
 * so this route renders the shell with the same flags as every other route
 * and draws its cards as a CHILD of it — a hook in this body would sit above
 * the provider and read the empty default (lib/businessCard.ts's trap).
 */
export function AdminHome({ me }: { me: Me }) {
  const canModerate = can(me, 'content.moderate')

  return (
    <AppShell
      current="Admin home"
      canAdmin={can(me, 'admin.roles')}
      canShop={canReachShopAdmin(me)}
      canModerate={canModerate}
      canStarsAdmin={can(me, 'stars.admin')}
      canPhotoRoom={canGallery(me)}
      canAnalytics={can(me, 'analytics.read')}
      canNotices={can(me, 'content.publish')}
      canAudit={can(me, 'audit.read')}
      supportLanes={myLanes(me)}
      userName={me.displayName}
      userInitials={initialsOf(me.displayName)}
      userRole={me.roles[0]?.name ?? 'No role'}
      locale={me.locale}
      onSignOut={() => supabase.auth.signOut()}
    >
      <AdminHomeCards />
    </AppShell>
  )
}
